(function () {
  var CONFIG = window.ML_WHOP_CHECKOUT_CONFIG || window.WHOP_CHECKOUT_CONFIG || {}, CHECKOUT_BASE_URL = String(CONFIG.checkoutUrl || CONFIG.checkoutBaseUrl || CONFIG.hostedCheckoutUrl || "").replace(/\/$/, "");
  if (CONFIG.enabled === !1 || !CHECKOUT_BASE_URL)
    return;
  var isOpening = !1, openingStartedAt = 0, CART_ATTEMPTS = 12, CHECKOUT_VERSION = "20260916-google-attribution-1", CHECKOUT_SELECTORS = ["button[name=\"checkout\"]", "button[type=\"submit\"][name=\"checkout\"]", "input[name=\"checkout\"]", "input[type=\"submit\"][name=\"checkout\"]", "a[href=\"/checkout\"]", "a[href^=\"/checkout?\"]", "#checkout", ".cart__checkout-button", "[form=\"cart\"][name=\"checkout\"]", "[data-cart-checkout]", "[data-checkout-button]", "[data-testid*=\"checkout\" i]", "[aria-label*=\"checkout\" i]", "[aria-label*=\"afrekenen\" i]", "[aria-label*=\"pagamento\" i]", "[aria-label*=\"cassa\" i]"].join(",");
  function hasText(value, needle) {
    return String(value || "").toLowerCase().indexOf(needle) !== -1;
  }
  function findCheckoutTextTarget(el) {
    if (!el || !el.closest)
      return null;
    var target = el.closest("button, input, a");
    if (!target)
      return null;
    var text = String(target.innerText || target.value || target.getAttribute("aria-label") || "").toLowerCase(), href = target.getAttribute && target.getAttribute("href"), name = target.getAttribute && target.getAttribute("name"), id = target.getAttribute && target.getAttribute("id");
    return name === "checkout" || id === "checkout" || href === "/checkout" || String(href || "").indexOf("/checkout?") === 0 || (hasText(text, "checkout") || hasText(text, "afrekenen") || hasText(text, "secure checkout") || hasText(text, "check out") || hasText(text, "pagamento") || hasText(text, "cassa")) && target.closest("form, .cart, .drawer, [class*=\"cart\"], [id*=\"cart\"]") ? target : null;
  }
  function normalizeImage(url) {
    return url ? String(url).indexOf("//") === 0 ? window.location.protocol + String(url) : String(url) : null;
  }
  function centsFromMoney(text) {
    var cleaned = String(text || "").replace(/[^0-9.,]/g, "");
    if (!cleaned)
      return 0;
    var decimalAt = Math.max(cleaned.lastIndexOf("."), cleaned.lastIndexOf(",")), following = decimalAt === -1 ? -1 : cleaned.length - decimalAt - 1, whole = cleaned, fraction = "";
    (following === 1 || following === 2) && (whole = cleaned.slice(0, decimalAt), fraction = cleaned.slice(decimalAt + 1)), whole = whole.replace(/[.,]/g, "");
    var cents = Number(whole || "0") * 100 + Number((fraction + "00").slice(0, 2));
    return isFinite(cents) ? Math.round(cents) : 0;
  }
  function variantIdFromRow(row) {
    if (!row)
      return null;
    var direct = row.getAttribute("data-variant-id") || row.getAttribute("data-variant") || row.getAttribute("data-id");
    if (direct && /^\d+$/.test(String(direct).trim()))
      return String(direct).trim();
    var nested = row.querySelector("[data-variant-id], [data-variant]");
    if (nested) {
      var value = nested.getAttribute("data-variant-id") || nested.getAttribute("data-variant");
      if (value && /^\d+$/.test(String(value).trim()))
        return String(value).trim();
    }
    var link = row.querySelector("a[href*=\"variant=\"]");
    if (link) {
      var fromHref = String(link.getAttribute("href") || "").match(/[?&]variant=(\d+)/);
      if (fromHref)
        return fromHref[1];
    }
    var input = row.querySelector("input[name^=\"updates[\"], input[name=\"id\"], input[data-quantity-variant-id]");
    if (input) {
      var name = String(input.getAttribute("name") || ""), fromName = name.match(/updates\[(\d+)\]/);
      if (fromName)
        return fromName[1];
      var byAttr = input.getAttribute("data-quantity-variant-id");
      if (byAttr && /^\d+$/.test(byAttr))
        return byAttr;
      if (name === "id" && /^\d+$/.test(String(input.value || "").trim()))
        return String(input.value).trim();
    }
    var keyed = row.querySelector("[data-line-item-key], [data-key]"), key = keyed ? keyed.getAttribute("data-line-item-key") || keyed.getAttribute("data-key") : row.getAttribute("data-key");
    if (key) {
      var fromKey = String(key).match(/^(\d+):/);
      if (fromKey)
        return fromKey[1];
    }
    return null;
  }
  function getCartFromDom() {
    var rows = Array.prototype.slice.call(document.querySelectorAll(".m-cart-item, [data-cart-item]")), items = rows.map(function (row, idx) {
      var titleEl = row.querySelector("a[href*=\"/products/\"], .m-cart-item__title, [data-cart-item-title]"), qtyEl = row.querySelector("input[type=\"number\"], input[name*=\"quantity\"]"), imageEl = row.querySelector("img"), moneyEls = Array.prototype.slice.call(row.querySelectorAll("*")).filter(function (el) {
        return /(?:\$|€|£|USD|EUR|GBP)\s*\d/i.test(el.textContent || "");
      }), priceText = moneyEls.length ? moneyEls[moneyEls.length - 1].textContent : "", quantity = qtyEl ? parseInt(qtyEl.value || "1", 10) : 1, linePrice = centsFromMoney(priceText);
      return { variant_id: variantIdFromRow(row), quantity: quantity || 1, title: (titleEl && titleEl.textContent || "Cart item " + (idx + 1)).trim(), sku: null, price: quantity ? Math.round(linePrice / quantity) : linePrice, final_line_price: linePrice, image: imageEl ? imageEl.currentSrc || imageEl.src : null };
    }).filter(function (item) {
      return item.final_line_price > 0;
    }), totalPrice = items.reduce(function (sum, item) {
      return sum + item.final_line_price;
    }, 0);
    if (!items.length || !totalPrice)
      throw new Error("Could not read cart from page");
    return { currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || CONFIG.currency || "USD", item_count: items.reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0), total_price: totalPrice, items: items };
  }
  function sleep(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }
  function cartHasItems(cart) {
    return !!(cart && Number(cart.item_count || 0) > 0 && Array.isArray(cart.items) && cart.items.length > 0 && Number(cart.total_price || 0) > 0);
  }
  function readShopifyCart() {
    var controller = window.AbortController ? new AbortController : null, timeout = controller ? window.setTimeout(function () {
      controller.abort();
    }, 2500) : null;
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store", headers: { Accept: "application/json" }, signal: controller ? controller.signal : void 0 }).then(function (r) {
      if (timeout && window.clearTimeout(timeout), !r.ok)
        throw new Error("Could not read Shopify cart");
      return r.json();
    }).catch(function (error) {
      throw timeout && window.clearTimeout(timeout), error;
    });
  }
  function getCart(attempt) {
    return attempt = attempt || 0, readShopifyCart().then(function (cart) {
      return cartHasItems(cart) ? cart : attempt < CART_ATTEMPTS ? sleep(220 + attempt * 260).then(function () {
        return getCart(attempt + 1);
      }) : getCartFromDom();
    }).catch(function (error) {
      if (attempt < CART_ATTEMPTS)
        return sleep(220 + attempt * 260).then(function () {
          return getCart(attempt + 1);
        });
      try {
        return getCartFromDom();
      }
      catch (domError) {
        throw error || domError;
      }
    });
  }
  function normalizeVariantOptions(item) {
    var optionsWithValues = Array.isArray(item.options_with_values) ? item.options_with_values : [], options = optionsWithValues.map(function (option) {
      var name = String(option.name || option.title || "").trim(), value = String(option.value || "").trim();
      return !name || !value || value.toLowerCase() === "default title" ? null : { name: name, value: value };
    }).filter(Boolean);
    if (options.length)
      return options;
    var variantOptions = Array.isArray(item.variant_options) ? item.variant_options : [];
    if (options = variantOptions.map(function (value, index) {
      return value = String(value || "").trim(), !value || value.toLowerCase() === "default title" ? null : { name: "Option " + (index + 1), value: value };
    }).filter(Boolean), options.length)
      return options;
    var variantTitle = String(item.variant_title || "").trim();
    return variantTitle && variantTitle.toLowerCase() !== "default title" ? variantTitle.split("/").map(function (value, index) {
      return value = String(value || "").trim(), value ? { name: "Option " + (index + 1), value: value } : null;
    }).filter(Boolean) : [];
  }
  function toCheckoutPayload(cart) {
    var items = (cart.items || []).map(function (item) {
      return { variantId: item.variant_id ? "gid://shopify/ProductVariant/" + item.variant_id : null, title: item.product_title || item.title || "Cart item", quantity: Number(item.quantity || 1), priceCents: Number(item.price || 0), finalLinePriceCents: Number(item.final_line_price || 0), finalPriceCents: Number(item.final_price || 0), image: normalizeImage(item.image), sku: item.sku || null, variantTitle: item.variant_title || null, options: normalizeVariantOptions(item) };
    }).filter(function (item) {
      return item.quantity > 0 && item.priceCents > 0;
    });
    return { cartToken: String(cart.token || "").trim(), attribution: currentAttribution(), currency: (cart.currency || window.Shopify && window.Shopify.currency && window.Shopify.currency.active || CONFIG.currency || "USD").toUpperCase(), totalCents: Number(cart.total_price || items.reduce(function (sum, item) {
        return sum + item.priceCents * item.quantity;
      }, 0)), originalTotalCents: Number(cart.original_total_price || cart.items_subtotal_price || items.reduce(function (sum, item) {
        return sum + item.priceCents * item.quantity;
      }, 0)), shopifyDiscountCents: Number(cart.total_discount || 0), shopifyDiscounts: [].concat(cart.cart_level_discount_applications || []).concat((cart.items || []).reduce(function (all, item) {
        return all.concat(item.discount_allocations || []);
      }, [])).map(function (discount) {
        var _a;
        return { title: String(discount.title || ((_a = discount.discount_application) == null ? void 0 : _a.title) || "").slice(0, 80), amountCents: Number(discount.total_allocated_amount || discount.amount || 0) };
      }).filter(function (discount) {
        return discount.title || discount.amountCents > 0;
      }).slice(0, 10), itemCount: Number(cart.item_count || items.reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0)), lineItems: items };
  }
  var ATTRIBUTION_STORAGE_KEY = "ml_ad_attribution", ATTRIBUTION_FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "gbraid", "wbraid"], ATTRIBUTION_MAX_AGE_MS = 90 * 86400000;
  function captureAttribution() {
    try {
      var params = new URLSearchParams(window.location.search), values = {}, found = !1;
      ATTRIBUTION_FIELDS.forEach(function (field) {
        var value = params.get(field);
        value && (values[field] = String(value).slice(0, 256), found = !0);
      });
      found && window.localStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify({ at: Date.now(), values: values }));
    }
    catch (error) {
    }
  }
  function storedAttribution() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(ATTRIBUTION_STORAGE_KEY) || "null");
      return saved && saved.values && Date.now() - Number(saved.at || 0) < ATTRIBUTION_MAX_AGE_MS ? saved.values : {};
    }
    catch (error) {
      return {};
    }
  }
  function clickIdFromCookie(name) {
    try {
      var match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
      if (!match)
        return "";
      var parts = decodeURIComponent(match[1]).split(".");
      return parts.length >= 3 ? parts.slice(2).join(".") : "";
    }
    catch (error) {
      return "";
    }
  }
  function currentAttribution() {
    var values = storedAttribution(), result = {};
    ATTRIBUTION_FIELDS.forEach(function (field) {
      values[field] && (result[field] = values[field]);
    });
    if (!result.gclid && !result.gbraid && !result.wbraid) {
      var fromCookie = clickIdFromCookie("_gcl_aw"), braid = clickIdFromCookie("_gcl_gb");
      fromCookie && (result.gclid = fromCookie), braid && (result.gbraid = braid);
    }
    return result;
  }
  function base64UrlEncode(value) {
    var json = JSON.stringify(value), encoded = btoa(unescape(encodeURIComponent(json)));
    for (encoded = encoded.split("+").join("-").split("/").join("_"); encoded.charAt(encoded.length - 1) === "=";)
      encoded = encoded.slice(0, -1);
    return encoded;
  }
  function redirectToHostedCheckout(cart) {
    var payload = toCheckoutPayload(cart);
    if (!payload.lineItems.length || !payload.totalCents)
      throw new Error("Cart is empty");
    var missing = payload.lineItems.filter(function (item) {
      return !item.variantId;
    });
    if (missing.length)
      throw new Error("Cart is missing variant ids");
    var url = CHECKOUT_BASE_URL + "/checkout?cart=" + encodeURIComponent(base64UrlEncode(payload));
    window.location.assign(url);
  }
  function setButtonBusy(clicked, busy) {
    if (clicked) {
      if (busy) {
        clicked.setAttribute("aria-busy", "true");
        return;
      }
      clicked.removeAttribute("aria-busy"), (clicked.tagName === "BUTTON" || clicked.tagName === "INPUT") && clicked.dataset.hostedCheckoutWasDisabled !== "true" && (clicked.disabled = !1);
    }
  }
  function fallbackToShopifyCheckout(reason, clicked) {
    isOpening = !1, openingStartedAt = 0, console.error("Hosted checkout failed:", reason), setButtonBusy(clicked, !1), window.location.assign("/checkout");
  }
  function resetOpeningState() {
    isOpening = !1, openingStartedAt = 0, healCheckoutButtons();
  }
  function startHostedCheckout(evt) {
    if (evt && typeof evt.preventDefault == "function" && evt.preventDefault(), evt && typeof evt.stopPropagation == "function" && evt.stopPropagation(), evt && typeof evt.stopImmediatePropagation == "function" && evt.stopImmediatePropagation(), isOpening && openingStartedAt && Date.now() - openingStartedAt > 3000 && resetOpeningState(), isOpening)
      return !1;
    isOpening = !0, openingStartedAt = Date.now();
    var clicked = null;
    return evt && evt.target && evt.target.closest && (clicked = evt.target.closest("button, input, a"), clicked && (clicked.dataset.hostedCheckoutWasDisabled = clicked.disabled ? "true" : "false", setButtonBusy(clicked, !0))), getCart().then(redirectToHostedCheckout).catch(function (reason) {
      fallbackToShopifyCheckout(reason, clicked);
    }), !1;
  }
  function buttonLooksLikeReadyCheckout(el) {
    if (!el)
      return !1;
    var text = String(el.innerText || el.value || el.getAttribute("aria-label") || "").toLowerCase(), hasCheckoutText = hasText(text, "checkout") || hasText(text, "check out") || hasText(text, "afrekenen") || hasText(text, "pagamento") || hasText(text, "cassa") || el.getAttribute("name") === "checkout", hasMoney = /(?:£|€|\$|gbp|eur|usd)\s*\d/i.test(text) || !!(el.querySelector && el.querySelector("[ymq-cart-money], .ymq-cart-app-total")), cartLooksReady = !!document.querySelector(".ymq-cart-app-checkout-button, .ymq-cart-app-total, .cart-item, .m-cart-item, [data-cart-item]");
    return !!(hasCheckoutText && (hasMoney || cartLooksReady));
  }
  function healCheckoutButtons() {
    document.querySelectorAll(CHECKOUT_SELECTORS).forEach(function (el) {
      buttonLooksLikeReadyCheckout(el) && (el.disabled || el.getAttribute("aria-busy") === "true") && (el.disabled = !1, el.removeAttribute("aria-busy"));
    });
  }
  function handleCheckoutClick(evt) {
    var target = evt.target && evt.target.closest ? evt.target.closest(CHECKOUT_SELECTORS) || findCheckoutTextTarget(evt.target) : null;
    if (target)
      return startHostedCheckout(evt);
  }
  function handleCartSubmit(evt) {
    var submitter = evt.submitter || document.activeElement, isCheckoutSubmit = submitter && (submitter.matches && submitter.matches(CHECKOUT_SELECTORS) || findCheckoutTextTarget(submitter)), formLooksLikeCart = evt.target && evt.target.matches && evt.target.matches("form[action=\"/cart\"], form[action$=\"/cart\"]");
    if (!(!isCheckoutSubmit && (!formLooksLikeCart || !findCheckoutTextTarget(submitter))))
      return startHostedCheckout(evt);
  }
  function bindCheckoutButtons() {
    document.querySelectorAll(CHECKOUT_SELECTORS).forEach(function (el) {
      buttonLooksLikeReadyCheckout(el) && el.disabled && (el.disabled = !1, el.removeAttribute("aria-busy")), el.dataset.hostedCheckoutBound !== "true" && (el.dataset.hostedCheckoutBound = "true", (el.tagName === "BUTTON" || el.tagName === "INPUT") && el.setAttribute("type", "button"), el.tagName === "A" && el.setAttribute("href", "#hosted-checkout"), el.addEventListener("click", startHostedCheckout, !0));
    });
  }
  function initHostedCheckoutOverride() {
    bindCheckoutButtons(), healCheckoutButtons();
    var observer = new MutationObserver(bindCheckoutButtons);
    observer.observe(document.documentElement, { childList: !0, subtree: !0 }), window.setInterval(healCheckoutButtons, 1000);
  }
  captureAttribution(), window.__startHostedCheckout = startHostedCheckout, window.__whopHostedCheckoutVersion = CHECKOUT_VERSION, window.__resetHostedCheckout = resetOpeningState, document.addEventListener("click", handleCheckoutClick, !0), document.addEventListener("submit", handleCartSubmit, !0), window.addEventListener("pageshow", resetOpeningState), window.addEventListener("popstate", resetOpeningState), window.addEventListener("focus", resetOpeningState), document.addEventListener("visibilitychange", function () {
    document.hidden || resetOpeningState();
  }), document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", initHostedCheckoutOverride) : initHostedCheckoutOverride();
})();
